<script>
export default {
	props: ['project'],
};
</script>

<template>
	<router-link
		:to="{ path: `/projects/single-project`, query: { id: project.id } }"
		class="group flex flex-col rounded-lg overflow-hidden border transition-all duration-300 mb-8 sm:mb-0
			bg-white dark:bg-white/[0.045]
			border-gray-200 dark:border-white/[0.08]
			shadow-sm shadow-gray-200/70 dark:shadow-black/20
			hover:border-amber-400/60 dark:hover:border-amber-500/40
			hover:shadow-2xl hover:shadow-amber-500/10 dark:hover:shadow-amber-500/15
			hover:-translate-y-1"
		aria-label="Single Project"
	>
		<!-- Image wrapper: fixed 16:9 aspect ratio -->
		<div class="relative overflow-hidden bg-gray-100 dark:bg-white/[0.04]" style="aspect-ratio: 16/9;">
			<!-- Skeleton shimmer shown while image loads -->
			<div class="absolute inset-0 animate-pulse bg-gradient-to-br from-gray-200 to-gray-100 dark:from-white/[0.06] dark:to-white/[0.02]" />

			<img
				:src="project.img"
				:alt="project.title"
				loading="lazy"
				class="absolute inset-0 w-full h-full object-cover object-top
					transition-all duration-500
					group-hover:scale-105
					opacity-0"
				@load="$event.target.classList.add('opacity-100')"
			/>

			<!-- Bottom gradient for smooth text blend -->
			<div class="absolute bottom-0 left-0 right-0 h-16
				bg-gradient-to-t from-black/40 to-transparent
				opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

			<!-- Category badge -->
			<span class="absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-general-medium
				bg-black/50 backdrop-blur-md text-white/90 border border-white/15
				transition-opacity duration-200">
				{{ project.category }}
			</span>

			<!-- Hover overlay arrow -->
			<div class="absolute bottom-3 right-3 w-8 h-8 rounded-lg flex items-center justify-center
				bg-white/20 backdrop-blur-sm border border-white/30
				opacity-0 group-hover:opacity-100
				translate-y-2 group-hover:translate-y-0
				transition-all duration-300">
				<svg class="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7" />
				</svg>
			</div>
		</div>

		<!-- Info -->
		<div class="flex flex-col flex-1 px-5 py-5">
			<h3 class="font-general-semibold text-sm sm:text-base text-gray-900 dark:text-white font-semibold leading-snug
				group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors duration-200 line-clamp-2">
				{{ project.title }}
			</h3>

			<div v-if="project.tools && project.tools.length" class="mt-3 flex flex-wrap gap-1.5">
				<span
					v-for="tool in project.tools.slice(0, 3)"
					:key="tool"
					class="px-2 py-1 rounded-md text-[11px] font-general-medium bg-gray-100 text-gray-500 dark:bg-white/[0.06] dark:text-slate-400"
				>
					{{ tool }}
				</span>
			</div>

			<div class="mt-auto pt-3 flex items-center gap-1 text-xs font-general-medium
				text-gray-400 dark:text-slate-500 group-hover:text-amber-500 dark:group-hover:text-amber-400 transition-colors duration-200">
				View project
				<svg class="w-3 h-3 transition-transform duration-200 group-hover:translate-x-0.5"
					fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
				</svg>
			</div>
		</div>
	</router-link>
</template>
